import type { FC, SyntheticEvent } from "react";

import { Autocomplete, Chip, Stack, TextField } from "@mui/material";
import CustomButton from "./CustomButton";

import { fireEvent } from "@testing-library/react";

interface ChipAutocompleteProps {
  id: string;
  label: string;
  value: string[];
  onChange: (event: SyntheticEvent, value: (string | string[])[]) => void;
}

export const ChipAutocomplete: FC<ChipAutocompleteProps> = ({
  id,
  label,
  value,
  onChange,
}) => {
  return (
    <Autocomplete
      id={id}
      style={{ marginBottom: 40 }}
      multiple
      options={[]}
      freeSolo
      value={value}
      onChange={onChange}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip variant='outlined' label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          variant='outlined'
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Stack direction='row' spacing={1}>
                <CustomButton
                  size='micro'
                  style={{ width: 40 }}
                  title='+'
                  onClick={() => {
                    const element = document.getElementById(id);
                    if (element) {
                      fireEvent.keyDown(element, { key: "Enter" });
                    }
                  }}
                />
                {params.InputProps.endAdornment}
              </Stack>
            ),
          }}
        />
      )}
    />
  );
};
